export class SeatRequest {
    seatAdjustment: number;
}
